// Texts of the shared list/table components (src/components/data).
const dataTable = {
  search: {
    minChars: 'At least 3 characters',
    clear: 'Clear search',
  },
  statusLabel: 'Status filter',
  filters: 'Filters',
  filtersOpen: 'Filters ({{count}} on)',
  clearAll: 'Clear all',
  removeFilter: 'Remove the {{label}} filter',
  pendingFilter: 'This filter applies from 3 characters',
  columns: {
    button: 'Columns',
    buttonLabel: 'Columns ({{count}}/{{total}} shown)',
    title: 'Column visibility',
    visible: '{{count}} / {{total}} shown',
    showAll: 'Show all',
    reset: 'Reset to default',
    resetHint: 'Default columns and widths',
    lastColumn: 'At least one column must stay visible',
  },
  filter: {
    title: '{{label}} filter',
    titleOn: '{{label}} filter (on)',
    placeholder: 'Search…',
    clear: 'Clear',
    minChars: 'Type at least 3 characters',
    all: 'All',
  },
  table: {
    resizeLabel: 'Width of the {{label}} column',
    resizeHint: 'Drag to change the width, double-click to reset',
    scrollLeft: 'Scroll the table left',
    scrollRight: 'Scroll the table right',
    noColumns: 'No visible columns',
    showDefaultColumns: 'Show default columns',
    clearFilters: 'Clear filters',
    loading: 'Loading',
  },
  pagination: {
    noResults: 'No results',
    loading: 'Loading…',
    pages: 'Pages',
    first: 'First page',
    previous: 'Previous page',
    next: 'Next page',
    last: 'Last page',
    page: 'Page {{page}}',
  },
  panel: {
    previous: 'Previous record',
    next: 'Next record',
    close: 'Close (Esc)',
    actions: 'Actions',
    details: 'Details',
    copy: 'Copy',
    copyLabel: 'Copy {{label}}',
    copied: '{{label}} copied',
    copyFailed: 'Could not copy to the clipboard',
  },
  filterSheet: {
    subtitle: 'Narrow the list down by column',
    show: 'Show {{count}} results',
  },
  form: {
    noOptions: 'No results',
    back: 'Back',
    nextSection: 'Next',
    stepOf: '{{current}} / {{total}}',
    sections: 'Form sections',
    outOfList: '{{value}} (not in list)',
    unsaved: 'You have unsaved changes.',
    keepEditing: 'Keep editing',
    discard: 'Close without saving',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving…',
    choose: 'Select',
    required: 'This field is required',
    fixErrors: 'Please correct the highlighted fields.',
    confirmDelete: 'Delete it?',
    delete: 'Delete',
    edit: 'Edit',
  },
};

export default dataTable;
